import styled from 'styled-components';
import { SubmitButton } from '@bit/wavfichacerta.fichacerta.shared-styles.buttons';

export const ContainerForm = styled.div`
  height: 91.5vh;
  max-height: 91.5vh;
`;

export const FormWrapper = styled.div`
  margin: auto;
`;

export const ButtonForm = styled(SubmitButton)`
  color: ${props => props.theme.color_white};
  font-size: 12px !important;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 10px;
  min-height: 40px;
  padding: 0.55rem 1.25rem !important;
  background: ${({$onBlue}) => (
    $onBlue
      ? `linear-gradient(
          165deg,
          #ffc56b 0%,
          #ff9f2e 18%,
          #ff7200 45%,
          #e85d00 72%,
          #c44a00 100%
        )`
      : `linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)`
  )} !important;
  box-shadow: ${({$onBlue}) => (
    $onBlue
      ? `0 2px 8px rgba(255, 114, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25)`
      : `0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25)`
  )};
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

  &:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
    box-shadow: ${({$onBlue}) => (
      $onBlue
        ? `0 4px 14px rgba(255, 114, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3)`
        : `0 1px 0 rgba(255, 255, 255, 0.15) inset, 0 4px 14px rgba(21, 43, 78, 0.35)`
    )};
  }

  &:active {
    transform: translateY(0);
    filter: brightness(0.98);
  }
`;

export const ContainerCheckbox = styled.div`
  width: 25%;
  & label { margin-top: 0; margin-bottom: 0; }
  & > div {
    margin-top: 0;
  }
  & > div {
    &:last-child {
      & > div {
        display: flex;
        justify-content: space-between;
      }
      & > div > div { width: auto;margin: 0 .5rem; }
    }
  }
`;

export const ContainerRadio = styled.div`
  width: 25%;
  & label { margin-top: 0; margin-bottom: 0; }
  & > div {
    margin-top: 0;
    &:last-child {
      & > div {
        display: flex;
        justify-content: space-between;
      }
      & > div > div { width: auto;margin: 0 .5rem; }
    }
  }
  &:last-child {
    padding: 0;
  }
  & label { 
    &::before { content: none !important; }
  }
`;

export const ContainerRadioCobranca = styled(ContainerRadio)`
  width: auto;
  margin: 0;
  
  & > div > div {
    padding: 0;
    &.col {
      display: none;
    }
    & > div {
      margin: 0 0 0 20px !important;
    }
  }

  input[type='radio'] {
    height: initial !important;

    :checked:after {
      width: 6px;
      height: 6px;
      border-radius: 6px;
      top: 3px;
      left: 3px;
      position: absolute;
      background-color: #152b4e;
      content: '';
      display: inline-block;
      visibility: visible;
    }
  }
`;
